function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 62,
  r: 60.5,
  stroke: "#2E4F70",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M78.1854 96.9867L76.9108 97.7774L77.7015 99.0521L78.9762 98.2613L78.1854 96.9867ZM90.104 89.5929L90.8947 90.8676L92.1694 90.0768L91.3786 88.8022L90.104 89.5929ZM78.9762 98.2613L87.8047 92.7845L86.2232 90.2352L77.3947 95.712L78.9762 98.2613ZM87.8047 92.7845L88.9083 92.0999L87.3268 89.5506L86.2232 90.2352L87.8047 92.7845ZM89.3132 88.3183L87.3268 89.5506L88.9083 92.0999L90.8947 90.8676L89.3132 88.3183ZM65.7039 79.7122L69.7791 86.2814L72.3284 84.6999L68.2532 78.1307L65.7039 79.7122ZM69.7791 86.2814L76.9108 97.7774L79.4601 96.1959L72.3284 84.6999L69.7791 86.2814ZM77.6224 72.3184L81.6976 78.8876L84.2469 77.3061L80.1717 70.737L77.6224 72.3184ZM81.6976 78.8876L88.8293 90.3837L91.3786 88.8022L84.2469 77.3061L81.6976 78.8876ZM71.8445 86.7653L77.8038 83.0684L76.2223 80.5191L70.263 84.216L71.8445 86.7653ZM77.8038 83.0684L83.763 79.3715L82.1815 76.8222L76.2223 80.5191L77.8038 83.0684Z",
  fill: "#2E4F70"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58.7232,
  cy: 54.9155,
  r: 25.3825,
  transform: "rotate(-31.8138 58.7232 54.9155)",
  stroke: "#2E4F70",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.4286 44H69.858V46.8572H48.4286V44ZM67.0007 62.5721H69.858V58.2862H71.2866V55.429L69.858 48.2859H48.4286L47 55.429V58.2862H48.4286V66.858H61.2862V58.2862H67.0007V62.5721ZM58.429 64.0007H51.2859V58.2862H58.429V64.0007ZM49.9144 55.429L50.7716 51.1431H67.515L68.3722 55.429H49.9144Z",
  fill: "#2E4F70"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.858 62.5721H67.0007V66.858H69.858V62.5721Z",
  fill: "#2E4F70"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 65,
  height: 72,
  fill: "white",
  transform: "translate(32 28)"
})));

function SvgDiscovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/Discovery.b0f2ce8b.svg";
export { ForwardRef as ReactComponent };